import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledTrademark } from './Styles';

const Trademark = () => (
  <StyledTrademark>
    <FormattedMessage
      id="tr5.trademark"
      values={{ year: new Date().getFullYear() }}
    />
  </StyledTrademark>
);

export default Trademark;
